class Validator {
    /**
     * 
     * @param {String} email 
     * @returns {Boolean}
     */
    isEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    /**
     * 
     * @param {String} str
     * @returns {Boolean}
     */
    isEmpty(str) {
        return str.trim().length === 0
    }

    isPhoneNumber(phoneNumber) {
        // Remove all non-numeric characters
        const cleanNumber = phoneNumber.replace(/\D/g, '');

        // Check if the number is 9 digits long
        if (cleanNumber.length !== 9) {
            return false;
        }

        // Check that the first digit is 6
        if (cleanNumber[0] !== '6') {
            return false;
        }

        // If all checks pass, return true!
        return true;
    }

    /**
     * 
     * @param {String} haystack
     * @param {String} needle
     * @return {Boolean}
     */
    contains(haystack, needle) {
        return haystack.includes(needle)
    }
}
var validator = new Validator()
export default validator;